export default __webpack_public_path__ + "static/gnosis-1673e4425186a41e57de7ee29bf39f35.png";